import { z } from 'zod'

const envSchema = z.object({
    NEXT_PUBLIC_POSTHOG_KEY: z.string().min(1),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().min(1),
    NEXT_PUBLIC_API_URL: z.string().min(1),
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().min(1).optional(),
})

export const env = envSchema.parse({
    // Don't forget to include NEXT_PUBLIC_ manually here so the bundler can inject them
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
} satisfies Record<keyof z.infer<typeof envSchema>, string | undefined>)

export const hasStripePublishableKey = Boolean(env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY)
